<template>
  <div id="shop-product-detail">
    <!-- header image -->
    <v-container fluid pa-0>
      <v-layout align-center justify-center row wrap>
        <v-flex pt-0 sm6 xs12>
          <v-img :src="require('@/assets/shop/shop_header.png')" width="100%"></v-img>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- content -->
    <v-container grid-list-xl pt-0>
      <v-layout align-center justify-center row wrap>
        <v-flex px-0 py-0 sm8 xs12>
          <v-img :src="require('@/assets/shop/shop_header-1.png')" width="100%"></v-img>
        </v-flex>
      </v-layout>

      <v-layout align-center justify-center :key="state.idx" row v-for="state in states" wrap>
        <v-flex py-0 sm4 xs8>
          <v-img
            aspect-ratio="1"
            contain
            :src="state.picture ? state.picture : require('@/assets/NoPicture.png')"
          ></v-img>
        </v-flex>
        <v-flex pb-4 pt-0 text-xs-center xs12>
          <div class="body-3 spacing-3">{{ mapPlaceName(state.subDistrict, state.province) }}</div>
        </v-flex>
        <ShopProductItem />
      </v-layout>
    </v-container>
  </div>
</template>

<script>
const ShopProductItem = () => import('@/components/shop/ShopProductItem')
export default {
  name: 'shop-product-detail',
  components: {
    ShopProductItem
  },
  data() {
    return {
      states: []
    }
  },
  computed: {
    shopEditionProductId() {
      return atob(this.$route.params.shopEditionProductId)
    },
    provinces() {
      return this.$store.getters['Place/getProvinceAll']
    },
    subDistricts() {
      return this.$store.getters['Place/getSubDistrictAll']
    }
  },
  mounted() {
    this.fethShopProduct()
  },
  methods: {
    async fethShopProduct() {
      try {
        const response = await this.axios.get(`farmerspace/shop/product`)
        this.states = response.data.filter(item => item.idx == this.shopEditionProductId)
      } catch (error) {
        throw new Error(error)
      }
    },
    mapPlaceName(subDistrictId, provinceId) {
      let subDistrictName = this.subDistricts
        .filter(item => item.id == subDistrictId)
        .map(item => item.nameeng)
        .toString()
      let provinceName = this.provinces
        .filter(item => item.id == provinceId)
        .map(item => item.nameeng)
        .toString()
      return `${subDistrictName} / ${provinceName}`
    }
  }
}
</script>

<style lang="scss" scoped>
.spacing-2 {
  letter-spacing: 2px !important;
}
.spacing-3 {
  letter-spacing: 3px !important;
}
</style>
